import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonText,
} from "@ionic/react";

import React from "react";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import {
  settingsOutline,
  logOutOutline,
  receiptOutline,
  receiptSharp,
  busOutline,
  busSharp
} from "ionicons/icons";

import { injectContext, AppProps } from "../base/AppContext";

import { UserPhoto } from "./Ui/UserPhoto";

import "./Menu.css";

interface MenuProps extends RouteComponentProps {
  selectedPage: string;
}

interface AppPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
}

const appPages: AppPage[] = [
  {
    title: "Passagens",
    url: "/page/passages",
    iosIcon: receiptOutline,
    mdIcon: receiptSharp,
  },
  {
    title: "Veiculos",
    url: "/page/cars",
    mdIcon: busOutline,
    iosIcon: busSharp
  }
  // {
  //   title: "Outbox",
  //   url: "/page/Outbox",
  //   iosIcon: paperPlaneOutline,
  //   mdIcon: paperPlaneSharp,
  // },
];

const Menu: React.FunctionComponent<MenuProps & AppProps> = ({
  selectedPage,
  logout,
  isAuth,
  user,
  loading,
}) => {
  const onLogout = () => {
    logout();
  };
  return (
    <IonMenu disabled={!isAuth} contentId="main" type="overlay">
      <IonContent>
        <IonList id="inbox-list">
          <div className="menu-header">
            <IonMenuToggle autoHide={false}>
              <Link to="/page/my-account">
                <IonItem button lines="none">
                  <UserPhoto />
                  <IonText style={{ textTransform: "capitalize" }}>
                    {user.name}
                  </IonText>
                  <IonIcon slot="end" icon={settingsOutline} />
                </IonItem>
              </Link>
            </IonMenuToggle>
          </div>

          {appPages.map((appPage, index) => {
            return (
              <IonMenuToggle key={index} autoHide={false}>
                <Link to={appPage.url}>
                  <IonItem
                    button
                    className={selectedPage === appPage.title ? "selected" : ""}
                    lines="none"
                    detail={false}
                  >
                    <IonIcon slot="start" icon={appPage.iosIcon} />
                    <IonLabel>{appPage.title}</IonLabel>
                  </IonItem>
                </Link>
              </IonMenuToggle>
            );
          })}
          {/* <IonMenuToggle autoHide={false}> */}
          <IonItem button onClick={onLogout} lines="none" detail={false}>
            <IonIcon slot="start" icon={logOutOutline} />
            <IonLabel>Sair</IonLabel>
          </IonItem>
          {/* </IonMenuToggle> */}
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default withRouter(injectContext(Menu));
